/**
 * The dashboard.
 */
import { useQuery } from '@tanstack/react-query';
import * as miscApi from '../api/Misc';
import { parsed } from '../api/parse';
import type { ModuleCode } from '../features/modules/modules';
import { dashboardOverviewSchema } from '../schemas';
import { keys } from './keys';

/**
 * The overview, re-read while something is still processing.
 *
 * `refetchIntervalInBackground` is left at its default of false, so a
 * backgrounded tab stops polling — the same instinct as turning
 * `refetchOnWindowFocus` off: work the reader cannot see is work not worth
 * doing, and an audit tool left open in a spare tab should not keep asking.
 */
export function useDashboardQuery(active: boolean, module: ModuleCode) {
	return useQuery({
		queryKey: keys.dashboard.overview(module),
		queryFn: async () =>
			parsed(
				dashboardOverviewSchema,
				await miscApi.getDashboardOverview(module),
				`/dashboard?module=${module}`,
			),
		refetchInterval: active ? 4000 : false,
	});
}
